<header>
  <button class="close-side-bar" (click)="closeSideBar()">
    <app-icon icon="close" class="close-icon"></app-icon>
  </button>
  <nav class="f-col" role="navigation">
    <div class="top f-col">
      <div class="heading">
        <img class="serve-logo" src="assets/logo-white.svg" alt="LU Serve Logo">
        <div class="role-text x-small-reg-text">ADMINISTRATOR</div>
      </div>
      <div class="nav-list f-col">

        <button id="users-tab" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'users']">
          <app-icon icon="user" class="large-icon"></app-icon>
          <span class="small-medium-text">Users</span>
        </button>

        <button class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'organizations']">
          <app-icon icon="globe" class="large-icon"></app-icon>
          <span class="small-medium-text">Organizations</span>
        </button>

        <button id="supervisor" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'supervisors']">
          <app-icon icon="users" class="large-icon"></app-icon>
          <span class="small-medium-text">Supervisors</span>
        </button>

        <button id="opportunities" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'opportunities']">
          <app-icon icon="building" class="large-icon"></app-icon>
          <span class="small-medium-text">Opportunities</span>
        </button>

        <button id="volunteers" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'placements']">
          <app-icon icon="heart-outline" class="large-icon"></app-icon>
          <span class="small-medium-text">Placements</span>
        </button>

        <hr>

        @if (isAdminApproval()) {
          <button id="approvals" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'approvals']">
            <app-icon icon="check-square" class="large-icon"></app-icon>
            <span class="small-medium-text">Approvals</span>
          </button>
        }
        <button id="announcements" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'announcements']">
          <app-icon icon="megaphone" class="large-icon"></app-icon>
          <span class="small-medium-text">Announcements</span>
        </button>
        <button id="termEvents" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'terms']">
          <app-icon icon="settings-cog" class="large-icon"></app-icon>
          <span class="small-medium-text">Terms</span>
        </button>
        <button id="failedSubmissions" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'failed-submissions']">
          <app-icon icon="alert-circle" class="large-icon"></app-icon>
          <span class="small-medium-text">Failed Submissions</span>
        </button>

        <hr>

          <!--        <button id="uploads" class="nav-button gap-3"-->
          <!--                routerLinkActive="admin-active-page" [routerLink]="['/', 'admin', 'uploads']"-->
          <!--                *ngIf="isAdmin$ | async">-->
          <!--              <app-icon icon="upload" class="large-icon"></app-icon>-->
          <!--              <span class="small-medium-text">Uploads</span>-->
      <!--        </button>-->

      <button id="settings" class="nav-button gap-3" routerLinkActive="admin-active-page" [routerLink]="['/','admin','settings']">
        <app-icon icon="settings-cog" class="large-icon"></app-icon>
        <span class="small-medium-text">Global Settings</span>
      </button>

      </div>
    </div>

    <div class="footer f-col">
      <div class="admin-info f-col">
        <div class="supervisor-name small-bold-text">{{userName}}</div>
        <a href="{{userEmail}}" class="email small-email-text">{{userEmail}}</a>
      </div>
      <button class="custom-button-large-primary-admin-blue small-medium-text" [routerLink]="['/', 'student-dashboard']">Student</button>
      @if (isSupervisor$ | async) {
        <button
          class="custom-button-large-primary-admin-blue small-medium-text"
        [routerLink]="['/','supervisor']">Supervisor</button>
      }
      <button class="custom-button-large-primary-admin-blue small-medium-text" (click)="openImpersonateModal()">Impersonate</button>
      <button class="custom-button-large-primary-admin-blue small-medium-text" (click)="logOut()">Log Out</button>
    </div>
  </nav>
</header>

@if (modalOpen) {
  <app-impersonate-modal (closeModal)="onModalClose()"></app-impersonate-modal>
}
